<template>
  <div class="badge" :class="badgeType" :style="{ height: height + 'px', width: width + 'px' }">
    <div class="main-body">
      <slot name="main"></slot>
    </div>
    <div class="type-body">
      <slot name="type"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    badgeType: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 48,
    },
  },
};
</script>
<style lang="scss" scoped>
.badge {
  position: relative;
  background-image: url('~@/assets/images/bg_mini_ticket.webp');
  z-index: 1;
  overflow: hidden;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  .type-body {
    position: absolute;
    right: 0;
    
    font-size: 9px;
    font-weight: 600;
    color: #fff;
    text-transform: uppercase;
    transform: rotate(-90deg) translateX(75%);
    text-align: left;
    transform-origin: 100% 100%;
    margin-right: 12px;
  }
  &.minor {
    background-image: url('~@/assets/images/bg_minor_ticket.webp');

    .type-body {
      margin-right: 16px;
      transform: rotate(-90deg) translateX(65%);
    }
  }

  &.major {
    background-image: url('~@/assets/images/bg_major_ticket.webp');
    .type-body {
      margin-right: 20px;
      transform: rotate(-90deg) translateX(65%);
    }
  }

  .main-body {
    
    font-size: 12px;
    font-weight: 800;
    color: #fff;
    margin-right: 36%;
  }
}
</style>
